import PasswordStrengthBar from 'react-password-strength-bar';
import { WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import Component from "../../../components/Component";
import withAxios, { IAxiosProps } from "../../../components/withAxios";
import Headerpage from 'src/components/header';
import "src/pages/home/signUp-pages/style.css";
import { AppContextConsumer, IAppContext } from "src/components/withAppContext";
import { Redirect, withRouter } from 'react-router-dom';
import Footerpage from 'src/components/footer';
import EmailValidator from "email-validator";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Visibility from "@material-ui/icons/Visibility";

const styles = () => ({
  childTemplate: {
    paddingLeft: 80,
  },
  listItem: {
    "&:hover": {
      backgroundColor: "#e6e6e6",
    },
    backgroundColor: "white",
  },
});

type IProps = IAxiosProps & IAppContext &
  WithStyles<keyof ReturnType<typeof styles>> & { history: any };

interface ITemplatesPageState {
  email: string;
  password: string;
  emailErr: string;
  passwordErr: string;
  loader: boolean;
  redirect: boolean;
  showPassword: boolean;
  emailExistingCheck?: any;

}

const Home = withStyles(styles)(
  withAxios(
    class SignUpStepOne extends Component<IProps, ITemplatesPageState> {
      public state = this.buildState({
        email: '',
        password: '',
        emailErr: '',
        passwordErr: '',
        loader: false,
        redirect: false,
        showPassword: false,
        emailExistingCheck:"",
      });

      public constructor(props: any) {
        super(props);
      }
      public async emailExistingCheck() {
        if(this.state?.email){
            const resEmail: any = await this.buildGet(this, `school/user/${this.state?.email}`)()
            console.log("resEmail", resEmail)
            //  this.setState({emailExistingCheck:resEmail})
            const invitationMessage = "It looks like an invitation may have already been sent to this email. Please check your inbox, or contact your school administrator if you need a new invitation.";
            this.setState({emailExistingCheck:resEmail, emailErr: resEmail?.hasPendingInvitation ? invitationMessage : resEmail?.message || ''})
            if (resEmail?.hasPendingInvitation) {
                return true
            }
            if (resEmail?.status === true) {
                return false // means email id not exists
            } else {
                return true
            }
        }else{
            return false
        }
      
    }
      public componentWillMount() {
        this.props.getNewLoginUserDetails();
      }

      public componentDidMount = async() => {
      
        this.setState({ redirect: false });
        window.scrollTo({ top: 0, behavior: "smooth" });
        if (this.props?.newUserDetails?.email) {
          this.setState({ email: this.props.newUserDetails.email });
        }
      }

      public nextHandler = async() => {
        const { email, password } = this.state;
      
        this.setState({ emailErr: '', passwordErr: '' });

        let hasError = false;

        if (email.trim() === '') {
          this.setState({ emailErr: 'Email is required' });
          hasError = true;
        } else if (!EmailValidator.validate(email.trim())) {
          this.setState({ emailErr: 'Enter a valid email address' });
          hasError = true;
        }

        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
        if (password.trim() === '') {
          this.setState({ passwordErr: 'Password is required' });
          hasError = true;
        } else if (!passwordRegex.test(password)) {
          this.setState({
            passwordErr: 'Password must be at least 8 characters and include an uppercase letter, lowercase letter, number, and special character',
          });
          hasError = true;
        }
        if (email && password && !hasError){
        const isCheck = await this.emailExistingCheck()
       
        if(isCheck){
          //  // this.setState({ emailErr: 'This email is already registered. Please try another one.' });
          // this.setState({ emailErr: this.state?.emailExistingCheck?.message });
          return;
        }else{
          this.setState({ emailErr: '' });
        if (!hasError) {
          this.props.onChangeUserDetails({
            ...this.props?.newUserDetails,
            email: email.trim(),
            password: password.trim(),
          });
          this.props.history.push('/name');
        }
      }
    }
      }
       public readonly handleResendInvite = () => async () => {
        alert("Resend Invite clicked");
              const payload = {
                email: this.state.email.trim(),
              };
              try {
                await this.buildPost<typeof payload, any>(
                  this,
                  "/resend-invitation"
                )(payload);
                window.alert("Invite resent successfully.");
              } catch (error) {
                window.alert("Failed to resend invite.");
              }
            };


      public render() {
        return (
          <>
            {this.state.redirect && <Redirect to="/school" />}
         <Headerpage/>

            <div className="container-inner">
              <div className="content-leader" style={{
                width: "100%",
                height: "calc(100vh - 153px)",
                backgroundImage: `-webkit-gradient(linear, left top, left bottom, from(rgba(62, 124, 177, 0.5)), to(rgba(62, 124, 177, 0.5))),url(${require('src/assets/gritp.jpg')})`
              }}>
                <div className="signup-main-content signup_outer_box"
    //             style={{
    //               maxHeight: "calc(100vh - 153px)",
    //               overflowY: "auto",
    //               scrollbarWidth: 'none',          // Firefox
    // msOverflowStyle: 'none',         // IE 10+
    // WebkitOverflowScrolling: 'touch',
    //             }}
              >
              
                  <div className="sign-main-inner-content">
                    <h1>Welcome to Grit Leadership!<br />
                      Let's start with your login details.</h1>

                    <form>
                      <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 p-0">
                          <input
                            type="email"
                            className="form-control sign-first-control"
                            placeholder="Email"
                            autoComplete="off"
                            value={this.state.email}
                            onChange={(event) => {
                              const email = event.target.value;
                              this.setState({
                                email,
                                emailErr: email.trim() === ''
                                  ? 'Email is required'
                                  : !EmailValidator.validate(email.trim())
                                    ? 'Please enter a valid email'
                                    : '',
                              });
                            }} />
                          {this.state.emailErr && <div className="span-error" style={{ color: 'red' }}>{this.state.emailErr}</div>}
                        </div>

                        <div className="col-lg-12 col-md-12 col-sm-12 p-0">
                          {/* Input + Icon wrapper */}
                          <div style={{ position: 'relative' }}>
                            <input
                              type={this.state.showPassword ? "text" : "password"}
                              className="form-control sign-las-control"
                              placeholder="Password"
                              autoComplete="new-password"
                              value={this.state.password}
                              onFocus={async () => {
                                // Check email when password field is focused
                                if (this.state?.email && EmailValidator.validate(this.state.email.trim())) {
                                  const isCheck = await this.emailExistingCheck();
                                  if (isCheck && this.state?.emailExistingCheck?.message) {
                                    this.setState({ emailErr: this.state?.emailExistingCheck?.message });
                                  }
                                }
                              }}
                              onChange={(event) => {
                                const value = event.target.value;
                                const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

                                this.setState({
                                  password: value,
                                  passwordErr: value === ''
                                    ? 'Password is required'
                                    : !passwordRegex.test(value)
                                      ? 'Password must be at least 8 characters and include an uppercase letter, lowercase letter, number, and special character'
                                      : '',
                                });
                              }}
                              style={{ paddingRight: '40px' }}
                            />
                            <div
                              style={{
                                position: 'absolute',
                                right: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                cursor: 'pointer',
                                zIndex: 2,
                              }}
                              onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                            >
                              {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                            </div>
                          </div>

                          {/* Error and strength bar outside of input container */}
                          <div style={{ minHeight: '20px', marginTop: '5px' }}>
                            {this.state.passwordErr && (
                              <div className="span-error" style={{ color: 'red' }}>{this.state.passwordErr}</div>
                            )}
                          </div>

                          {this.state.password && <PasswordStrengthBar password={this.state.password} />}
                        </div>
                      </div>
                    </form>

                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", marginBottom: "30px" }}>
                      <button className="next-btn-inner" onClick={() => {
                        this.nextHandler();
                      }}><span className="next-span-btn">NEXT</span></button>
                      {this.state.emailExistingCheck?.hasPendingInvitation && (
                        <button
                          type="button"
                          className="next-btn-inner"
                          onClick={() => this.props.history.push(`/pending-invite?email=${encodeURIComponent(this.state.email.trim().toLowerCase())}`)}
                        >
                          <span className="next-span-btn">ACCEPT</span>
                        </button>
                      )}
                    </div>
                    {/* {this.state?.emailExistingCheck?.hasPendingInvitation
                    &&
                    <button className="next-btn-inner" style={{marginBottom:"30px", marginLeft:"10px"}} onClick={this.handleResendInvite}><span className="next-span-btn">RESEND</span></button>
                  } */}
                  </div>
                </div>
              </div>
            </div>

           <Footerpage/>
          </>
        );
      }
    }
  )
);

const HomeFunction = (props: any) => {
  return (
    <AppContextConsumer>
      {(context) => <Home {...context} history={props?.history} />}
    </AppContextConsumer>
  );
};

export default withRouter(HomeFunction);






// WEBPACK FOOTER //
// ./src/pages/home/signUp/signup.tsx